const sidebars = {
  namespaced: true,
  state: () => ({
    loginAside: false,
    profileAside: false,
    menuAside: false,
    notificationsAside: false,
    feedbackAside: false
  }),
  mutations: {
    loginAsideOpen (state) {
      state.loginAside = true;
    },
    loginAsideClose (state) {
      state.loginAside = false;
    },
    profileAsideOpen (state) {
      state.profileAside = true;
    },
    profileAsideClose (state) {
      state.profileAside = false;
    },
    menuAsideOpen (state) {
      state.menuAside = true;
    },
    menuAsideClose (state) {
      state.menuAside = false;
    },
    notificationsAsideOpen (state) {
      state.notificationsAside = true;
    },
    notificationsAsideClose (state) {
      state.notificationsAside = false;
    },
    feedbackAsideOpen (state) {
      state.feedbackAside = true;
    },
    feedbackAsideClose (state) {
      state.feedbackAside = false;
    },
    asideClose (state) {
      Object.keys(state).forEach((key) => {
        state[key] ? state[key] = false : null
      }, state);
    }
  },
  getters: {
    getLoginAside: (state) => {
      return state.loginAside
    },
    getProfileAside: (state) => {
      return state.profileAside
    },
    getMenuAside: (state) => {
      return state.menuAside
    },
    getNotificationsAside: (state) => {
      return state.notificationsAside
    },
    getFeedbackAside: (state) => {
      return state.feedbackAside
    }
  }
}
export default sidebars
